import styled from 'styled-components';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { rem } from '~/src/helpers/rem-converter.helper';

export const SectionContainerLeadPage = styled.section`
    width: 100%;
    flex-direction: column;
    gap: ${rem(24)};
`;

export const TitleLeadPage = styled.h3`
    ${FONTS.compact.medium.size20};
    margin-bottom: ${rem(24)};
`;
